import { getEnvironment, ENVIRONMENTS } from './whitelist';

export const LEVEL = {
    ERROR: 'error',
    WARN: 'warn',
    INFO: 'info',
    LOG: 'log'
};

const COLOR = {
    ERROR: 'background-color: lightcoral; color: white;',
    WARN: 'color: darkorange; ',
    INFO: 'color: gray;',
    LOG: 'color: darkgreen;'
};

class Logger {
    constructor(debug, debugGWE = false) {
        if (debug) {
            this._debug = debug;
        } else {
            this._debug = getEnvironment() === ENVIRONMENTS.PROD ? false : true;
        }
        this._debugGWE = debugGWE;
        this._domain = window.top === window ? 'WC PARENT' : 'WC CHILD';

        this.colorize = this.isChrome || this.isFirefox;
        this.errorCallback = [];

        // attach error handler only on child
        if (window.console && window.onerror && window.top !== window) {
            window.onerror = this.globalErrorHandler.bind(this);
        }
    }

    get isFirefox() {
        return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }

    get isChrome() {
        return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }

    get isIE() {
        return navigator.userAgent.match(/msie\s[5-9]|Trident|Edge/i) !== null;
    }

    setDomain(domain) {
        this._domain = domain;
    }

    setDebugGWE(debugGWE) {
        this._debugGWE = debugGWE;
    }

    enable(enable = true) {
        this._debug = enable;
    }

    disable() {
        this._debug = false;
    }

    mylog(message) {
        this.windowLogger('-', message);
    }

    /**
     * Window console logger (when console.log is not available) - only for debugging purposes!!!
     */
    windowLogger(level, message) {
        const prefix = level + ' ';

        if (document && document.body) {
            let loggerElement = document.getElementById('opl-logger');
            if (!loggerElement) {
                loggerElement = document.createElement('ul');
                loggerElement.id = 'opl-logger';
                loggerElement.style.cssText = 'background-color: white;';
                loggerElement.style.marginTop = '40px';
                document.body.appendChild(loggerElement);
            }
            if (loggerElement) {
                const item = document.createElement('li');
                item.style.cssText = COLOR[level] + 'white-space: pre-wrap;';
                item.textContent = prefix + message;
                loggerElement.appendChild(item);
            }
            const mv = document.getElementsByClassName('maximized-view');
            if (mv.length > 0) mv[0].style.backgroundColor = 'transparent';
        }
    }

    write(level, message, color = '') {
        if (!this._debug) return;

        try {
            // on IE/Edge wrap console.log into function (console.log is not a real function when debug console is closed)
            let logfunc = this.isIE
                ? (m) => window.console.log(m)
                : window.console && window.console.log
                ? window.console.log
                : undefined;
            let prefix = `${this._domain} ${level.toUpperCase()} `;

            if (!logfunc) return;

            if (this.colorize) {
                logfunc =
                    typeof window.console[level] === 'function' ? window.console[level] : logfunc;
                prefix = '%c' + prefix;
                try {
                    logfunc(prefix + message, color);
                } catch (ex) {
                    if (window.console) window.console.log(prefix + message);
                }
            } else {
                logfunc(prefix + message);
            }
        } catch (ex) {
            if (window.console) window.console.log(`WC ${level.toUpperCase()} ${message}`);
        }
    }

    globalErrorHandler({ source, lineno, error }) {
        const errorMessage = error.message;
        if (errorMessage.indexOf('Script error.') > -1) {
            return;
        }
        if (error != undefined) {
            this.error(`${errorMessage} ${lineno}@${source} Error: ${JSON.stringify(error)}`);
        } else {
            this.error(`${errorMessage} ${lineno}@${source}`);
        }
    }

    error(message, area) {
        this.write(LEVEL.ERROR, message, COLOR.ERROR);
        this.callOnError(message, area);
    }

    warn(message) {
        this.write(LEVEL.WARN, message, COLOR.WARN);
    }

    info(message) {
        this.write(LEVEL.INFO, message, COLOR.INFO);
    }

    log(message) {
        this.write(LEVEL.LOG, message, COLOR.LOG);
    }

    onError(callback) {
        this.errorCallback.push(callback);
    }

    callOnError(message, area) {
        if (this._debugGWE) {
            this.errorCallback.forEach((c) => c(message, area));
        }
    }

    attachGlobalErrorHandler() {
        window.addEventListener('error', (event) => {
            this.globalErrorHandler(event);
        });
    }
}

export default new Logger();
